/*
 * Authors: mariushirjanu
 * Created: 28/07/2020
 * Refactored: 15/03/2023
 */
import * as _ from 'underscore';
import { IOrderContext, IOrderPaymentType } from '../order-entry-data.service';
import { IDescribedStringObject } from '../../../../../type_definitions/datatypes';
import { Injectable } from '@angular/core';
import { EVENT_ORDER_PAYMENT_LIST_CHANGED } from '../../../../shared/app-events';
import { GaEventService } from '../../../../shared/services/ga-event.service';

@Injectable()
export class OrderEntryPaymentService {
  private _paymentType:IDescribedStringObject;
  private _paymentTypes:IDescribedStringObject[];
  private _localPaymentTerms:number;
  private _centralPaymentTerms:number;
  private _sowPaymentTerm:number;
  private _billingType:string;
  private _allowedPaymentTypes:IOrderPaymentType[];

  private readonly PAYMENT_TYPES:IDescribedStringObject[] = [
    {
      id: 'PO',
      description: 'ORDERENTRY.PAYMENT.BANK_TRANSFER'
    },
    {
      id: 'CC',
      description: 'ORDERENTRY.PAYMENT.CREDIT_CARD'
    },
    {
      id: 'PP',
      description: 'PayPal'
    }
  ];

  constructor(
    private eventService:GaEventService
  ) {
    /***/
  }

  public fromContext(shopContext:IOrderContext):void {
    this.allowedPaymentTypes = shopContext.allowedPaymentTypes;
    this.billingType = shopContext.billingType;
    this.setPaymentTypes(undefined, true);
    this.localPaymentTerms = shopContext.localPaymentTerms;
    this.centralPaymentTerms = shopContext.centralPaymentTerms;
  }

  public getPossiblePaymentTypes():IDescribedStringObject[] {
    const allowedPaymentTypes:string[] = _.findWhere(this.allowedPaymentTypes, { billingType: this.billingType })?.paymentTypes;

    return _.map(allowedPaymentTypes, (type:string) => {
      return _.findWhere(this.PAYMENT_TYPES, { id: type });
    });
  }

  public get allowedPaymentTypes():IOrderPaymentType[] {
    return this._allowedPaymentTypes;
  }

  public set allowedPaymentTypes(types:IOrderPaymentType[]) {
    this._allowedPaymentTypes = types;
  }

  public get paymentType():IDescribedStringObject {
    return this._paymentType;
  }

  public set paymentType(paymentType:IDescribedStringObject) {
    this._paymentType = paymentType;
  }

  public get paymentTypeId():string {
    return this._paymentType?.id;
  }

  public set paymentTypeId(paymentTypeId:string) {
    this._paymentType = _.findWhere(this._paymentTypes, { id: paymentTypeId });
  }

  public setPaymentTypes(paymentTypes?:IDescribedStringObject[], fromContext?:boolean):void {
    if (paymentTypes && paymentTypes.length || fromContext) {
      this._paymentTypes = fromContext? this.getPossiblePaymentTypes() : paymentTypes;
      this.eventService.sendMessage(EVENT_ORDER_PAYMENT_LIST_CHANGED, this._paymentTypes);

      //if there is a single payment type, we select it
      if (this._paymentTypes?.length === 1 && !this.paymentType) {
        this.paymentType = this._paymentTypes[0];
      }
    }
  }

  public get paymentTypes():IDescribedStringObject[] {
    return this._paymentTypes;
  }

  public get localPaymentTerms():number {
    return this._localPaymentTerms;
  }

  public set localPaymentTerms(paymentTerms:number) {
    this._localPaymentTerms = paymentTerms;
  }

  public get centralPaymentTerms():number {
    return this._centralPaymentTerms;
  }

  public set centralPaymentTerms(paymentTerms:number) {
    this._centralPaymentTerms = paymentTerms;
  }

  public get billingType():string {
    return this._billingType;
  }

  public set billingType(billingType:string) {
    this._billingType = billingType;
  }

  public clear():void {
    this._paymentType = undefined;
    this._paymentTypes = undefined;
    this._localPaymentTerms = undefined;
    this._centralPaymentTerms = undefined;
    this._sowPaymentTerm = undefined;
    this._billingType = undefined;
  }
}